export default __webpack_public_path__ + "static/media/Matteo.d08a6161.otf";